import ddt from '@wix/da-ddt';
import { takeEvery, all } from 'redux-saga/effects';
import localStorageWrapper from '../localStorageWrapper';
import { getStorageEventChannel } from '../utils';
import { setCompliantLocalStorageItem, removeCompliantLocalStorageItem, initializeCompliantLocalStorage } from './actions';
export function* setCompliantLocalStorageHandler(action) {
    ddt.log('compliantlocalstorage', `writing key: ${action.payload.key} to localStorage with value of: ${action.payload.value}`);
    localStorageWrapper.setItem(action.payload.key, action.payload.value || '');
}
export function* initializeCompliantLocalStorageHandler() {
    const handler = (event)=>{
        try {
            getStorageEventChannel().put(event);
        } catch (e) {
            ddt.log('compliantlocalstorage', 'Error from channel', event, e);
        }
    };
    window.addEventListener('storage', handler);
    return ()=>{
        window.removeEventListener('storage', handler);
    };
}
function* removeCompliantLocalStorageHandler(action) {
    const { key } = action.payload;
    ddt.log('compliantlocalstorage', `removing key: ${key}`);
    localStorageWrapper.removeItem(key);
}
export default function* saga() {
    yield all([
        takeEvery(initializeCompliantLocalStorage, initializeCompliantLocalStorageHandler),
        takeEvery(setCompliantLocalStorageItem, setCompliantLocalStorageHandler),
        takeEvery(removeCompliantLocalStorageItem, removeCompliantLocalStorageHandler)
    ]);
}

//# sourceMappingURL=saga.js.map